module.exports = __webpack_public_path__ + "static/img/200338.f84360b1.png";